import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import { ApolloProvider } from "@apollo/client";
import { Provider, useDispatch, useSelector } from 'react-redux';
import store from './store/store';
import Home from "./components/Dashboard/Home";
import LoginPage from "./components/LoginPage";
import ForgotPassword from "./components/forgotPassword";
import ResetPassword from "./components/resetPassword";
import { setUserToken } from './features/authSlice';
import Sidebar from "./sidebar/sidebar";
import { Layout } from "antd";
import ReusableHeader from "./reusableField/ReusableHeader";
import CreateClient from "./components/createClient";
import CreateClientForm from "./components/createClientForm";
import ImportFromLense from "./components/importFromLense";
import DynamicBreadcrumb from './components/dynamicBreadcrumb';
import { BreadcrumbProvider } from "./components/breadcrumbContext";
import ConfirmPassword from "./components/confirmPassword";
import client from "./services/apolloClient";
import JobRoles from "./components/jobRoles";
import Globaladmin from "./components/globalAdmin/globalAdmin";
import ViewRole from "./components/Dashboard/viewRole";
import UserManagement from "./components/Dashboard/Darts/masterConfiguration/userManagement/userManagement";
import GridWithAllFilters from "./components/agGrid";
import CalendarView from "./components/calendarView";
import BulkLeadsResult from "./components/bulkUploadResult";
import SuperManagerDashboard from "./components/Dashboard/superManagerDashboard";
import TargetFunnelPreview from "./components/Dashboard/Darts/masterConfiguration/productConfiguration/targetFunnelPreview";
import ITReports from "./components/powerBIReports/itReport";
import LeadIndicatorSelection from "./components/Dashboard/Darts/masterConfiguration/productConfiguration/leadIndicatorSelection";
import TicketingSystem from "../src/components/ticketingSystem/ticketingSystem";
import AttendanceDailyNorm from "./components/Dashboard/Darts/masterConfiguration/productConfiguration/attendancedailyNorm";
import KnowYourTabs from "./components/Dashboard/Clan/knowYourRole/knowYourTabs";
import StarsAdd from "./components/Dashboard/Clan/knowYourRole/Star/starsAdd";
import AddContentLibrary from "./components/Dashboard/Clan/knowYourRole/ContentLibrary/addContentLibrary";
import ContentLibraryAll from "./components/Dashboard/Clan/knowYourRole/ContentLibrary/contentLibraryAll";
import Activities from "./components/Dashboard/Darts/masterConfiguration/productConfiguration/activities";
import Statuses from "./components/Dashboard/Darts/masterConfiguration/productConfiguration/statuses";
import Stages from "./components/Dashboard/Darts/masterConfiguration/productConfiguration/stages";
import UserProfile from "./components/userProfilePage";
import ButtonAlignment from "./components/Dashboard/Darts/masterConfiguration/userManagement/buttonalignment";
import { ModuleRegistry } from 'ag-grid-community';
import { InfiniteRowModelModule } from 'ag-grid-community';
import ProductConfiguration from "./components/Dashboard/Darts/masterConfiguration/productConfiguration/productConfiguration";
import MastersConfiguration from "./components/Dashboard/Darts/masterConfiguration/mastersConfiguration";

import "./tailwind/tailwind.css";
import "./App.css";
import RoleManagement from "./components/roleManagement/roleManagement";
import RoleManagementView from "./components/roleManagement/roleManagementView";
import ClanCrewDashboard from "./components/clanCrew/clanCrewDashboard";
import ClanCrewUserManagement from "./components/clanCrew/clanCrewUserManagement";
import ClanCrewUserProfile from "./components/clanCrew/clanCrewUserProfile";
import ProductUpdates from "./components/Dashboard/Clan/knowYourRole/productUpdates";
import AdminDashboard from "./components/admin/adminDashboard";
import AdminHome from "./components/admin/adminHome";
import AdminViewRole from "./components/admin/darts/adminViewRole";
import AdminProductConfiguration from "./components/admin/darts/adminProductConfiguration";
import AdminAttendanceDailyNorm from "./components/admin/darts/adminAttendancedailyNorm";
import AdminStages from "./components/admin/darts/adminStages";
import AdminStatuses from "./components/admin/darts/adminStatuses";
import AdminActivities from "./components/admin/darts/adminActivities";
import AdminUserManagement from "./components/admin/darts/adminUserManagement";
import AdminMastersConfiguration from "./components/admin/darts/adminMastersConfiguration";
import AdminUserProfile from "./components/admin/darts/adminUserProfilePage";
import AdminKnowYourTabs from "./components/admin/clan/adminKnowYourTabs";
import AdminStarsAdd from "./components/admin/clan/adminStarsAdd";
import AdminAddContentLibrary from "./components/admin/clan/adminAddContentLibrary";
import ClanCrewHome from "./components/clanCrew/clanCrewHome";
import ViewRoles from "./components/Dashboard/viewRoles";
import FormsConfiguration from "./components/Dashboard/Darts/masterConfiguration/productConfiguration/formsConfiguration";
import NotificationSystem from "./components/clanCrew/notificationSystem";
import AdminITReports from "./components/admin/adminReports";
import ClanCrewUnderstandUserProfile from "./components/clanCrew/clanCrewUnderstandUserProfile";
import FAQPage from "./components/Dashboard/FAQPage";
import AdminFAQPage from "./components/admin/darts/adminFAQPage";
import MarkHoliday from "./components/Dashboard/markHoliday";
import ExperienceConfigurationUI from "./components/Dashboard/Darts/masterConfiguration/userManagement/experienceConfiguration";
import ProductsConfiguration from "./components/Dashboard/Darts/masterConfiguration/userManagement/productsConfiguration";
// import DartsFaqsContent from "./components/Dashboard/Darts/masterConfiguration/userManagement/dartsfaqscontent";
import SyncConfiguration from "./components/Dashboard/Sync/SyncConfiguration";
import StarVideoConfiguration from "./components/Dashboard/Sync/starVideoConfiguration/StarVideoConfiguration";
import SyncAddStar from "./components/Dashboard/Sync/starVideoConfiguration/SyncAddStar";
import AssessmentConfiguration from "./components/Dashboard/Sync/assessmentConfiguration/AssessmentConfiguration";
import DemographicJPFitmentScenario from "./components/Dashboard/Sync/assessmentConfiguration/DemographicJPFitmentScenario/DemographicJPFitmentScenario";
import AddQuize from "./components/Dashboard/Sync/assessmentConfiguration/DemographicJPFitmentScenario/AddQuize";
import ScenarioBasedAssessment from "./components/Dashboard/Sync/assessmentConfiguration/ScenarioBasedAssessment/ScenarioBasedAssessment";
import AssessmentJourney from "./components/Dashboard/Sync/AssessmentJourny/AssessmentJourney";
import AddScenario from "./components/Dashboard/Sync/assessmentConfiguration/ScenarioBasedAssessment/AddScenario";
import RoleDetailsConfiguration from "./components/Dashboard/Sync/roleDetailsConfiguration/RoleDetailsConfiguration";
import AddJobDetails from "./components/Dashboard/Sync/roleDetailsConfiguration/AddJobDetails";
import JPFitmentTest from "./components/Dashboard/Sync/assessmentConfiguration/jpFitment/JPFitmentTest";
import AddClientAndRole from "./components/clanLiteAndGrowthProject/AddClientAndRole";
import EditClientAndRole from "./components/clanLiteAndGrowthProject/EditClientAndRole";
import RoleManagementDashboard from "./components/clanLiteAndGrowthProject/RoleManagementDashboard";
import RoleMasterConfiguration from "./components/clanLiteAndGrowthProject/RoleMasterConfiguration";
import LiteGrowthHeader from "./components/clanLiteAndGrowthProject/LiteGrowthHeader";
ModuleRegistry.registerModules([InfiniteRowModelModule]);

// Protected Layout Component
const ProtectedLayout = ({ children, setIsAuthenticated }) => {
    const { pathname } = useLocation();
    const clanLitePaths = [
        "/add-client-and-role",
        "/clan-lite-growth-dashboard",
        "/role-master-configuration",
    ];
    const isClanLite =
        clanLitePaths.includes(pathname) ||
        pathname.match(/^\/edit-client-and-role\/[^/]+$/);

    return (
        <Layout style={{ minHeight: "100vh" }}>
            <Sidebar />
            <div style={{ flex: 1, paddingTop: 'var(--header-height)' }}>
                {isClanLite ? (
                    <LiteGrowthHeader setIsAuthenticated={setIsAuthenticated} />
                ) : (
                    <ReusableHeader setIsAuthenticated={setIsAuthenticated} />
                )}
                <DynamicBreadcrumb />
                {children}
            </div>
        </Layout>
    );
};

function App() {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const { access_token } = useSelector(state => state.auth);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    // Initial authentication check
    useEffect(() => {
        const token = localStorage.getItem("flutter.accessToken");
        if (token) {
            dispatch(setUserToken({ access_token: token }));
            setIsAuthenticated(true);
        } else {
            setIsAuthenticated(false);
            if (!location.pathname.includes('login') &&
                !location.pathname.includes('forgot-password') &&
                !location.pathname.includes('reset-password') &&
                !location.pathname.includes('confirmPassword')) {
                navigate('/login-page', { state: { from: location.pathname } });
            }
        }
    }, [dispatch, navigate, location.pathname]);

    // Monitor token changes
    useEffect(() => {
        if (access_token) {
            setIsAuthenticated(true);
        } else {
            setIsAuthenticated(false);
        }
    }, [access_token]);


    // Apollo Client default options
    client.defaultOptions = {
        watchQuery: {
            fetchPolicy: 'network-only',
            errorPolicy: 'ignore',
        },
        query: {
            fetchPolicy: 'network-only',
            errorPolicy: 'all',
        },
    };

    return (
        <BreadcrumbProvider>
            <Provider store={store}>
                <ApolloProvider client={client}>
                    <Routes>
                        {/* Public Routes */}
                        <Route
                            path="/login-page"
                            element={
                                isAuthenticated ? (
                                    <Navigate to={location.state?.from || "/dashboard"} replace />
                                ) : (
                                    <LoginPage setIsAuthenticated={setIsAuthenticated} />
                                )
                            }
                        />
                        <Route path="/forgot-password" element={<ForgotPassword />} />
                        <Route path="/reset-password" element={<ResetPassword />} />
                        <Route path="/confirmPassword" element={<ConfirmPassword />} />

                        {/* Protected Routes */}
                        <Route
                            path="/admin"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <Home />
                                </ProtectedLayout>
                            }
                        />
                        <Route
                            path="/create"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <CreateClient />
                                </ProtectedLayout>
                            }
                        />
                        <Route
                            path="/import-from-lense"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <ImportFromLense />
                                </ProtectedLayout>
                            }
                        />
                        <Route
                            path="/create-client-form"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <CreateClientForm />
                                </ProtectedLayout>
                            }
                        />
                        <Route
                            path="/job-roles"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <JobRoles />
                                </ProtectedLayout>
                            }
                        />
                        <Route
                            path="/global-admin"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <Globaladmin />
                                </ProtectedLayout>
                            }
                        />

                        <Route
                            path="/view-role"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <ViewRole />
                                </ProtectedLayout>
                            }
                        />

                        <Route
                            path="/faqs"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <FAQPage />
                                </ProtectedLayout>
                            }
                        />

                        <Route
                            path="/mark-holidays"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <MarkHoliday />
                                </ProtectedLayout>
                            }
                        />

                        <Route
                            path="/user-management"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <UserManagement />
                                </ProtectedLayout>
                            }
                        />


                        <Route
                            path="/ag-grid"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <GridWithAllFilters />
                                </ProtectedLayout>
                            }
                        />

                        <Route
                            path="/calendar-view"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <CalendarView />
                                </ProtectedLayout>
                            }
                        />

                        <Route
                            path="/bulk-leads-result"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <BulkLeadsResult />
                                </ProtectedLayout>
                            }
                        />
                        <Route
                            path="/dashboard"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <SuperManagerDashboard />
                                </ProtectedLayout>
                            }
                        />
                        <Route
                            path="/target-funnel-preview"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <TargetFunnelPreview />
                                </ProtectedLayout>
                            }
                        />
                        <Route
                            path="/reports"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <ITReports />
                                </ProtectedLayout>
                            }
                        />
                        <Route
                            path="/lead-indicator-selection"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <LeadIndicatorSelection />
                                </ProtectedLayout>
                            }
                        />
                        <Route
                            path="/ticketing-system"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <TicketingSystem />
                                </ProtectedLayout>
                            }
                        />
                        <Route
                            path="/attendance-daily-norm"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <AttendanceDailyNorm />
                                </ProtectedLayout>
                            }
                        />
                        <Route
                            path="/user/:id"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <UserProfile />
                                </ProtectedLayout>
                            }
                        />
                        <Route
                            path="/clan-management"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <KnowYourTabs />
                                </ProtectedLayout>
                            }
                        />
                        <Route
                            path="/add-stars"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <StarsAdd />
                                </ProtectedLayout>
                            }
                        />
                        <Route
                            path="/add-content-library"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <AddContentLibrary />
                                </ProtectedLayout>
                            }
                        />

                        <Route
                            path="/clan-management/stars"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <KnowYourTabs />
                                </ProtectedLayout>
                            }
                        />
                        <Route
                            path="/clan-management/content-library"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <KnowYourTabs />
                                </ProtectedLayout>
                            }
                        />
                        <Route
                            path="/clan-management/product-updates"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <KnowYourTabs />
                                </ProtectedLayout>
                            }
                        />
                        <Route
                            path="/more-videos"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <ContentLibraryAll />
                                </ProtectedLayout>
                            }
                        />
                        <Route
                            path="/activities"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <Activities />
                                </ProtectedLayout>
                            }
                        />
                        <Route
                            path="/statuses"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <Statuses />
                                </ProtectedLayout>
                            }
                        />
                        <Route
                            path="/stages"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <Stages />
                                </ProtectedLayout>
                            }
                        />
                        <Route
                            path="/products-Configuration"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <ProductConfiguration />
                                </ProtectedLayout>
                            }
                        />

                        {/* <Route
                            path="/claninputtypeconfiguration"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <ClanInputTypeConfiguration />
                                </ProtectedLayout>
                            }
                        /> */}

                        <Route
                            path="/masterConfiguration"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <MastersConfiguration />
                                </ProtectedLayout>
                            }
                        />

                        {/* <Route
                            path="/dartsfaqscontent"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <DartsFaqsContent />
                                </ProtectedLayout>
                            }
                        /> */}

                        <Route
                            path="/role-management"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <RoleManagement />
                                </ProtectedLayout>
                            }
                        />

                        <Route
                            path="/role-management-view"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <RoleManagementView />
                                </ProtectedLayout>
                            }
                        />

                        <Route
                            path="/clan-crew-dashboard"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <ClanCrewDashboard />
                                </ProtectedLayout>
                            }
                        />

                        <Route
                            path="/clan-crew-user-management"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <ClanCrewUserManagement />
                                </ProtectedLayout>
                            }
                        />

                        <Route
                            path="/clan-crew-user-profile/:id"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <ClanCrewUserProfile />
                                </ProtectedLayout>
                            }
                        />

                        <Route
                            path="/product-updates"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <ProductUpdates />
                                </ProtectedLayout>
                            }
                        />



                        <Route
                            path="/admin-dashboard"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <AdminDashboard />
                                </ProtectedLayout>
                            }
                        />

                        <Route
                            path="/admin-home"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <AdminHome />
                                </ProtectedLayout>
                            }
                        />

                        <Route
                            path="/productsConfiguration"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <ProductsConfiguration />
                                </ProtectedLayout>
                            }
                        />

                        <Route
                            path="/admin-view-role"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <AdminViewRole />
                                </ProtectedLayout>
                            }
                        />

                        <Route
                            path="/experience-configuration"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <ExperienceConfigurationUI />
                                </ProtectedLayout>
                            }
                        />

                        <Route
                            path="/admin-product-configuration"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <AdminProductConfiguration />
                                </ProtectedLayout>
                            }
                        />

                        <Route
                            path="/admin-attendance-daily-norm"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <AdminAttendanceDailyNorm />
                                </ProtectedLayout>
                            }
                        />

                        <Route
                            path="/admin-stages"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <AdminStages />
                                </ProtectedLayout>
                            }
                        />

                        <Route
                            path="/admin-statuses"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <AdminStatuses />
                                </ProtectedLayout>
                            }
                        />

                        <Route
                            path="/admin-activities"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <AdminActivities />
                                </ProtectedLayout>
                            }
                        />

                        <Route
                            path="/admin-user-management"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <AdminUserManagement />
                                </ProtectedLayout>
                            }
                        />

                        <Route
                            path="/admin-masters-configuration"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <AdminMastersConfiguration />
                                </ProtectedLayout>
                            }
                        />

                        <Route
                            path="/admin-user/:id"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <AdminUserProfile />
                                </ProtectedLayout>
                            }
                        />

                        <Route
                            path="/admin-clan-management"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <AdminKnowYourTabs />
                                </ProtectedLayout>
                            }
                        />

                        <Route
                            path="/admin-add-stars"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <AdminStarsAdd />
                                </ProtectedLayout>
                            }
                        />

                        <Route
                            path="/admin-add-content-library"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <AdminAddContentLibrary />
                                </ProtectedLayout>
                            }
                        />

                        <Route
                            path="/clan-crew-home"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <ClanCrewHome />
                                </ProtectedLayout>
                            }
                        />

                        <Route
                            path="/view-roles"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <ViewRoles />
                                </ProtectedLayout>
                            }
                        />

                        <Route
                            path="/forms-configuration"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <FormsConfiguration />
                                </ProtectedLayout>
                            }
                        />

                        <Route
                            path="/notification-system"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <NotificationSystem />
                                </ProtectedLayout>
                            }
                        />

                        <Route
                            path="/admin-reports"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <AdminITReports />
                                </ProtectedLayout>
                            }
                        />

                        <Route
                            path="/admin-faq"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <AdminFAQPage />
                                </ProtectedLayout>
                            }
                        />

                        <Route
                            path="/clan-crew-understand-userprofile"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <ClanCrewUnderstandUserProfile />
                                </ProtectedLayout>
                            }
                        />

                        <Route
                            path="/sync-Configuration"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <SyncConfiguration />
                                </ProtectedLayout>
                            }
                        />

                        <Route
                            path="/role-details-configuration"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <RoleDetailsConfiguration />
                                </ProtectedLayout>
                            }
                        />

                        <Route
                            path="/add-job-details"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <AddJobDetails />
                                </ProtectedLayout>
                            }
                        />

                        <Route
                            path="/star-video-configuration"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <StarVideoConfiguration />
                                </ProtectedLayout>
                            }
                        />

                        <Route
                            path="/syncAddStar"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <SyncAddStar />
                                </ProtectedLayout>
                            }
                        />

                        <Route
                            path="/assessment-configuration"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <AssessmentConfiguration />
                                </ProtectedLayout>
                            }
                        />
                        <Route
                            path="/demographicjp-fitment-scenario"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <DemographicJPFitmentScenario />
                                </ProtectedLayout>
                            }
                        />
                        <Route
                            path="/scenario-based-assessment"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <ScenarioBasedAssessment />
                                </ProtectedLayout>
                            }
                        />

                        <Route
                            path="/Add-Quize"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <AddQuize />
                                </ProtectedLayout>
                            }
                        />


                        <Route
                            path="/Assessment-journey"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <AssessmentJourney />
                                </ProtectedLayout>
                            }
                        />

                        <Route
                            path="/Add-Scenario"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <AddScenario />
                                </ProtectedLayout>
                            }
                        />

                        <Route
                            path="/jp-fitment-test"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <JPFitmentTest />
                                </ProtectedLayout>
                            }
                        />

                        <Route
                            path="/understand-user/:userId"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <ClanCrewUnderstandUserProfile />
                                </ProtectedLayout>
                            }
                        />

                        <Route
                            path="/add-client-and-role"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <AddClientAndRole />
                                </ProtectedLayout>
                            }
                        />

                        <Route
                            path="/edit-client-and-role/:id"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <EditClientAndRole />
                                </ProtectedLayout>
                            }
                        />

                        <Route
                            path="/role-master-configuration"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <RoleMasterConfiguration />
                                </ProtectedLayout>
                            }
                        />

                        <Route
                            path="/clan-lite-growth-dashboard"
                            element={
                                <ProtectedLayout isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                                    <RoleManagementDashboard />
                                </ProtectedLayout>
                            }
                        />

                        {/* Smart Root Redirect */}
                        <Route
                            path="/"
                            element={
                                <Navigate
                                    to={
                                        isAuthenticated
                                            ? (() => {
                                                const role = localStorage.getItem("userRole")?.toLowerCase(); // or from Redux
                                                if (role === "admin") return "/admin-dashboard";
                                                if (role?.includes("clan crew")) return "/clan-crew-dashboard";
                                                return "/dashboard"; // default
                                            })()
                                            : "/login-page"
                                    }
                                    replace
                                />
                            }
                        />
                    </Routes>
                </ApolloProvider>
            </Provider>
        </BreadcrumbProvider>
    );
}

export default App;